export type CrumbSlot = 'production' | 'set' | 'document' | 'pleading';

export interface CrumbContribution {
  slot: CrumbSlot;
  label: string;
  path?: string;
}

export const CRUMB_SLOTS: readonly CrumbSlot[] = [
  'production',
  'set',
  'document',
  // #1093 — the Claims Matrix is per pleading, so the matrix screen contributes
  // the pleading's short title ("2AC") and the Claims Matrix crumb above it
  // links back to the picker. Like `production`, the node is created by
  // resolveBreadcrumbs from the URL and only its LABEL comes from the screen:
  // the trail must exist before the fetch resolves, or a slow matrix renders
  // with no way back.
  'pleading',
];
